export default __webpack_public_path__ + "static/media/SplashScreen2.8caba725.mp4";